/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-info.vue?vue&type=template&id=1a89af5c&scoped=true&"
import script from "./authorize-info.vue?vue&type=script&lang=js&"
export * from "./authorize-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89af5c",
  null
  
)

export default component.exports